import { Text, View } from '@react-pdf/renderer';

import { salesComparisonPageStyles as styles } from '../styles.ts';
import type { SalesComparisonColumns, SalesComparisonGridColumnData } from '../types.ts';
import { buildSalesComparisonGlossaryText } from '../utils/buildSalesComparisonGlossaryText.ts';

export const SalesComparisonGlossary = ({
  filteredRows,
  properties,
}: {
  filteredRows: SalesComparisonColumns;
  properties: SalesComparisonGridColumnData[];
}) => {
  const text = buildSalesComparisonGlossaryText(filteredRows, properties);
  if (!text) return null;

  return (
    <View style={styles.glossary}>
      <Text style={styles.glossaryText}>{text}</Text>
    </View>
  );
};
